export default __webpack_public_path__ + "static/media/ai_right_bg.babbcb5e.png";